import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pinnedItemsState, pinnedItemDispatcher, filterDispatcher, combineDispatchers, filterSelectorState, combineStates, filterSelectedDispatcher } from '../../../../store';
import { translateProperty } from '../../../../util';
import { PropTypes } from 'prop-types';
import { Selection, SvgImage } from '../../../../components';
import { ViewItem } from '..';
import { CloseLightIconNew } from '../../../../../style/images';
import { translate } from '../../../../services';

export class FilterSelectorComponent extends Component {
  filter = filterValue => {
    const translated = translateProperty( filterValue.properties, filterValue.name );
    return filterValue && filterValue.name && filterValue.isAssignable && 
      filterValue.name.toUpperCase() !== 'NOT&#032;APPLICABLE' && 
      filterValue.name.toUpperCase() !== 'NOT APPLICABLE' &&
      filterValue.name.toUpperCase() !== 'DO NOT DISPLAY' &&
      translated.toUpperCase() !== 'NOT&#032;APPLICABLE' && 
      translated.toUpperCase() !== 'NOT APPLICABLE' &&
      translated.toUpperCase() !== 'DO NOT DISPLAY';
  }

  onFilterChanged = ( selectedItem, type ) => {
    const { filter, selectorName, pinnedItems } = this.props;
    let newValues = JSON.parse( JSON.stringify( filter.values ) );

    if( filter.properties && ( filter.properties.MultiSelectBehaviour === 'NONE' || !filter.properties.MultiSelectBehaviour ) && filter.values.any( i => i.isSelected && i.name !== selectedItem.name ) ) {
      newValues.first( i => i.isSelected && i.name !== selectedItem.name ).isSelected = false;
    }
    
    let item = {};
    if( type === "inputfield" ){
      item =selectedItem;
      newValues[0].name = selectedItem.name;
      newValues[0].value = selectedItem.value;
      newValues[0].isSelected=true;
      filter.isUserAssigned = true;
    }
    else{
      item = newValues.first( i => i.name === selectedItem.name );
      item.isSelected = !item.isSelected;
      if ( item.isSelected ) {
        filter.isUserAssigned = true;
      }
    }


    this.props.onFilterSelectorsChanged( { ...filter, values: newValues } ).then( (res) => {
      
      if ( selectedItem.isSelected && this.isPinned( selectedItem ) ) { //if selecting already selected item
        this.props.removePinnedItem( selectorName, filter.identifier, selectedItem.name );
      }
      
      else if(item.isSelected && this.isPinned( item )){ //if selecting any other new item
        this.props.removePinnedItem( selectorName, filter.identifier, item.name );
      }

      else if( pinnedItems[selectorName] && pinnedItems[selectorName][filter.identifier] ){// if selecting from same identifier
        !pinnedItems[selectorName][filter.identifier][item.name] && this.props.removePinnedFilter( selectorName, filter.identifier );
      }
      if(this.props.filterSelectors.length>0){
        const selectedFilter=this.props.filterSelectors?.filter(f=> f && f.values && f.values.any(v=>v.isSelected));
        if(selectedFilter.length==0){
          this.props.setFilterSelected(false);
        }
        else{
          this.props.setFilterSelected(true);
        }
  
      }
    } );
  }
  removeAssigned = ()=>{
    const { filter, selectorName } = this.props;
    let newValues = JSON.parse( JSON.stringify( filter.values ) );
    const item = newValues.first( i => i.isSelected );
      item.isSelected = !item.isSelected;
      if ( item.isSelected ) {
        filter.isUserAssigned = true;
      }
    this.props.onFilterSelectorsChanged( { ...filter, values: newValues } )
  }
  isPinned( item ) {
    const { filter, selectorName, pinnedItems } = this.props;
    return pinnedItems[selectorName] 
      && pinnedItems[selectorName][filter.identifier] 
      && pinnedItems[selectorName][filter.identifier][item.name];
  }
    
  isSelected = ( item, items ) => {
    return item && item.isSelected || this.isDefault( item, items );
  }

  isDefault = ( item, items ) => {
    const { filter } = this.props;
    return !filter.isUserAssigned && item && item.properties.State >= 3;
  }

  isForceable = ( item, items ) => {
    const { filter } = this.props;
    return !filter.isUserAssigned && item && item.properties.State === 0;
  }

  getUnit = ( filter, filterSelectors ) => {
    let unitValue = '';
    if ( !filter.properties.Unit || filter.properties.Unit.indexOf( 'Show:' ) !== 0 ) {
      return '';
    }
    const unitVariable = filter.properties?.Unit?.substring( 'Show:'.length );
    const matchingUnit = filterSelectors.firstOrDefault( v => v.name === unitVariable );
    matchingUnit.values.forEach(v => {
      if ( v.isAssignable == true && v.isSelected == true){
        unitValue += v.name ;
    }
    });
   
    // if ( !matchingUnit || !matchingUnit.assignedValue || !matchingUnit.assignedValue.title ) {
    if ( !unitValue ) {
      return '?';
    }
    // return ` (${ matchingUnit.assignedValue.title })`;
    return ` (${ unitValue })`;
  };

  getText = item => {
    return item && item.title?item.title:item?.name;
  }

  getValue = item => {
    return item && item.name;
  }

  render() {
    const { filter, selectorName, customeFilteImageTitle, filterSelectors, textField, valueField } = this.props;

    if( !filter || !filter.name ) {
      return null;
    }
    if ( filter.properties && ( filter.properties.Show === undefined || !filter.properties.Show ) ) {
      return null;
    }

    // const translated = filter.title;
    // const translated = filter.title + this.getUnit( filter, filterSelectors );
    const translated = filter.title ? filter.title + this.getUnit( filter, filterSelectors ) : filter.title;

    if ( !translated || translated.toUpperCase() === 'DO NOT DISPLAY' || filter.values.none( value => this.filter( value ) ) ) {
      return null;
    }
    
    return <Selection 
      groupName={ selectorName } 
      identifier={ filter.identifier }
      isSelected={ this.isSelected } 
      isDefault={ this.isDefault }
      isForceable={ this.isForceable }
      isRequired={ filter.properties.Required }
      disabled={ filter.properties.ReadOnly }
      multiselect={ filter.properties.MultiSelectBehaviour }
      pinnable 
      predicate={ this.filter } 
      onChange={ this.onFilterChanged }
      showHelp
      template={ ViewItem }
      title={ translated } 
      values={ filter.values }
      defaultFilter={filter.properties.EN}
      customeFilteImageTitle = {customeFilteImageTitle}
      ShowAs = {filter.properties.ShowAs?.toLowerCase()}
      textField = {this.getText}
      valuField = {this.getValue}
      selectedValue = {filter.values.filter(value=>value.isSelected)[0] || null}
      value ={filter.values[0].value}
      calculatedValue = {filter.properties.CalculatedValue}
      removeAssigned = {this.removeAssigned}
      filter={filter}
    />;
  }
}

FilterSelectorComponent.propTypes = {
  filter: PropTypes.shape( {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    properties: PropTypes.object,
    values: PropTypes.array
  } ), 
  filterSelectors: PropTypes.arrayOf( PropTypes.object ),
  onFilterSelectorsChanged: PropTypes.func.isRequired,
  pinnedItems: PropTypes.shape( {} ),
  removePinnedItem: PropTypes.func.isRequired,
  selectorName: PropTypes.string.isRequired
};

export const FilterSelector =  connect( combineStates( pinnedItemsState),
combineDispatchers( pinnedItemDispatcher, filterDispatcher, filterSelectedDispatcher)) ( FilterSelectorComponent );